module.exports = __webpack_public_path__ + "static/media/bg02-main2.d510d815.jpg";